import React, { memo, useMemo } from 'react';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  color: string;
}

export const Badge = memo(function Badge(props: BadgeProps) {
  // Memoize style object to prevent new object creation on every render
  const badgeStyle = useMemo(() => ({
    backgroundColor: props.color,
  }), [props.color]);

  return (
    <div {...props} className={`badge ${props.className} flex items-center justify-center text-center flex-row m-0 p-0`}>
      <span
        style={badgeStyle}
        className="badge-content text-sm font-medium px-3 py-1 rounded-full flex items-center justify-center text-center flex-row"
      >
        {props.children}
      </span>
    </div>
  );
});
